var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01204e-06 1.31931V11.6793C2.01204e-06 12.4693 0.870002 12.9493 1.54 12.5193L9.68 7.33931C9.82251 7.24912 9.9399 7.12435 10.0212 6.97661C10.1026 6.82887 10.1452 6.66296 10.1452 6.49431C10.1452 6.32566 10.1026 6.15974 10.0212 6.01201C9.9399 5.86427 9.82251 5.7395 9.68 5.64931L1.54 0.479309C1.38917 0.381754 1.2148 0.326716 1.0353 0.320003C0.855793 0.313289 0.677803 0.355149 0.520105 0.441166C0.362408 0.527182 0.23085 0.654167 0.13931 0.808724C0.0477698 0.96328 -0.000358634 1.13968 2.01204e-06 1.31931Z",
    fill: "#E6007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/ARROW.5e6452b6b9a9c79cde0a5de4ad187a5c.svg";
export { ForwardRef as ReactComponent };